import React from "react";
import cn from "classnames";
import { buttonVariants } from "theme/buttonVariants";

const InfoPanelComponent = ({
    state: {
        url = "",
        mobileUrl = "",
        displayOrder = "image-text",
        infoPanelHeading = "Heading",
        infoPanelText = "",
        infoPanelPrimaryButtonText = "",
        infoPanelPrimaryButtonLink = "",
        infoPanelPrimaryButtonColour = "primary",
        infoPanelSecondaryButtonText = "",
        infoPanelSecondaryButtonLink = "",
        infoPanelSecondaryButtonColour = "transparent",
        roundedImage = false,
    },
}) => {
    return (
        <div className="mx-auto flex flex-col gap-x-[30px] lg:flex-row lg:gap-x-[60px]">
            <div
                className={cn(
                    "flex-1",
                    displayOrder === "image-text"
                        ? "order-1"
                        : "order-2 lg:order-2",
                )}
            >
                <img
                    src={url}
                    alt={infoPanelHeading}
                    className={cn("w-full h-full object-cover", {
                        "hidden lg:block": !!mobileUrl,
                        "rounded-[10px]": roundedImage,
                    })}
                />

                {mobileUrl && (
                    <img
                        src={mobileUrl}
                        alt={infoPanelHeading}
                        className={cn(
                            "w-full h-full object-cover block lg:hidden",
                            {
                                "rounded-[10px]": roundedImage,
                            },
                        )}
                    />
                )}
            </div>
            <div
                className={cn(
                    "flex flex-1 flex-col justify-center px-0 py-[30px] lg:py-[60px]",
                    displayOrder === "image-text" ? "order-2" : "order-1",
                )}
            >
                {infoPanelHeading && (
                    <h2 className="text-[24px] text-brand-black leading-[30px] text-center lg:!text-left lg:!text-[40px] lg:!leading-[46px] font-extrabold mb-[15px]">
                        {infoPanelHeading}
                    </h2>
                )}
                {infoPanelText && (
                    <div
                        className="text-brand-black text-[16px] leading-[22px] lg:!text-[18px] lg:!leading-[24px]"
                        dangerouslySetInnerHTML={{ __html: infoPanelText }}
                    />
                )}
                <div className="flex gap-[10px] mt-[30px] flex-col lg:flex-row items-center lg:items-start">
                    {infoPanelPrimaryButtonLink && (
                        <a
                            type="button"
                            href={infoPanelPrimaryButtonLink}
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            className={cn(
                                buttonVariants[infoPanelPrimaryButtonColour]
                                    .solidClasses,
                                "!no-underline !hover:font-bold !font-bold !w-full lg:!w-auto",
                            )}
                        >
                            {infoPanelPrimaryButtonText}
                        </a>
                    )}

                    {infoPanelSecondaryButtonLink && (
                        <a
                            type="button"
                            href={infoPanelSecondaryButtonLink}
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            className={cn(
                                buttonVariants[infoPanelSecondaryButtonColour]
                                    ?.solidClasses,
                                "!no-underline !hover:font-bold !font-bold !w-full lg:!w-auto",
                            )}
                        >
                            {infoPanelSecondaryButtonText}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InfoPanelComponent;
